import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Axios from 'axios';
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
// import './assets/css/geral.css';
import './assets/css/geral.scss';
import './assets/css/color.scss';
import './assets/css/print.scss';
import {
	library
} from '@fortawesome/fontawesome';
import {
	fas
} from '@fortawesome/free-solid-svg-icons';
import {
	FontAwesomeIcon
} from '@fortawesome/vue-fontawesome';
import Vuelidate from 'vuelidate';
import jQuery from 'jquery';
import jQueryMask from 'jquery-mask-plugin';
import './assets/js/portal.js';
import {
	Pagination
} from 'bootstrap-vue/es/components';
import VueTheMask from 'vue-the-mask';
import money from 'v-money';
import VueCarousel from 'vue-carousel';
import PrettyCheckbox from 'pretty-checkbox-vue';
import Vuex from 'vuex';
import '../node_modules/pretty-checkbox/src/pretty-checkbox.scss';
import Dropdown from 'vue-simple-search-dropdown';
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import VuePaginate from 'vue-paginate'
import VueAnalytics from 'vue-analytics';
// import DisableAutocomplete from 'vue-disable-autocomplete';

// Vue.use(DisableAutocomplete);

import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";

if (window.location.href.toString().indexOf("rte.econeteditora.com.br") > -1) {
  Sentry.init({
    Vue,
    dsn: "https://8e4d0529c0604360981b43a1b415d204@o1250545.ingest.sentry.io/6415353",
    integrations: [new Integrations.BrowserTracing()],

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,
  });
}

Vue.use(VueAnalytics, {
	id: 'UA-143240836-1'
});

const moment = require('moment')
require('moment/locale/pt-br')

Vue.use(require('vue-moment'), {
	moment
})

Vue.use(Vuetify)
Vue.use(VuePaginate)
Vue.use(PrettyCheckbox);

Vue.use(VueCarousel);

Vue.use(VueTheMask);
Vue.use(money, {
	precision: 4
});
Vue.use(Pagination);
Vue.config.productionTip = false;
Vue.prototype.$http = Axios

Vue.use({
	install(Vue) {
		Vue.jQuery = jQuery
		Vue.prototype.$jQuery = jQuery
	}
})

Vue.use(jQueryMask);
Vue.use(BootstrapVue);
Vue.use(Vuelidate);
Vue.use(Dropdown);

library.add(fas);

Vue.component('font-awesome-icon', FontAwesomeIcon, 'modal-delete', {
	template: '#modal-template-delete',
});

const token = localStorage.getItem('token');
if (token) {
	Vue.prototype.$http.defaults.headers.common['Authorization'] = 'Bearer ' + token
}

export const EventBus = new Vue();

Object.defineProperties(Vue.prototype, {
	$bus: {
		get: function() {
			return EventBus;
		}
	},
	referrer: {
		configurable: true,
		writable: true,
		value: 'https://rte.econeteditora.com.br/cenario'
	}
});

new Vue({
	router,
	store,
	render: h => h(App),
}).$mount('#app');
